Watcher.observe('.js-default-gallery', blocks => {
  // Loop the blocks array
  blocks.forEach(block => {
    // Create a new modal
    const Modal = new window.ModalController({
      removeFromDOM: false
    });
    // The gallery list
    const list = block.querySelector('.js-default-gallery__list');
    // The slider items
    const items = [...list.children];
    // Find the modal content
    const content = block.querySelector('.js-default-gallery__modal');
    // Find the slider
    const slider = content.querySelector('.js-default-gallery__slider');
    // Find the slides
    const slides = [...slider.children];
    const removeVideos = () => {
      [...content.querySelectorAll('iframe')].forEach(iframe => {
        iframe.parentNode.removeChild(iframe);
      });
    };

    // When the modal opens, lock the scroll
    Modal.on('open', () => {
      window.ScrollLocker.lock();
    });

    // When the modal closes, unlock the scroll
    Modal.on('close', () => {
      window.ScrollLocker.unlock();
      removeVideos();
    });

    // Append the modal content to the modal
    Modal.append(content);

    // Create a new slider
    slider.tns = window.tns({
      container: slider,
      items: 1,
      slideBy: 'page',
      autoplay: false,
      controls: true,
      nav: false
    });

    // When the slide changes remove the videos
    slider.tns.events.on('indexChanged', removeVideos);

    // Loop through each item
    items.forEach((item, i) => {
      // Find the action button
      const action = item.querySelector('.js-default-gallery__action');

      // Open the modal when the action button is clicked
      action.addEventListener('click', () => {
        Modal.open();
        slider.tns.goTo(i);

        // If the slides[i] has a data-video, simulate a click event on it
        const video = slides[i].querySelector('[data-video]');

        // If there is no video, return
        if (!video) return;

        // Simulate a click event on the video
        video.dispatchEvent(new Event('click'));
      });
    });
  });
});